import type { ExtractThemeOverrides, Theme } from '../../_mixins/use-theme'
import type { ThemeCommonVars } from '../../_styles/common'
import type { ButtonTheme } from '../../button/styles'
import type { InputTheme } from '../../input/styles'
import { createTheme } from '../../_mixins/use-theme'
import { commonLight } from '../../_styles/common'
import { buttonLight } from '../../button/styles'
import { inputLight } from '../../input/styles'

export function self(vars: ThemeCommonVars) {
  const {
    fontSize,
    boxShadow2,
    popoverColor,
    textColor2,
    borderRadius,
    borderColor,
    heightSmall,
    heightMedium,
    heightLarge,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    dividerColor
  } = vars
  return {
    panelFontSize: fontSize,
    boxShadow: boxShadow2,
    color: popoverColor,
    textColor: textColor2,
    borderRadius,
    border: `1px solid ${borderColor}`,
    heightSmall,
    heightMedium,
    heightLarge,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    dividerColor
  }
}

export interface ColorPickerThemeVars extends ReturnType<typeof self> {}

const colorPickerLight: ColorPickerTheme = createTheme({
  name: 'ColorPicker',
  common: commonLight,
  peers: {
    Input: inputLight,
    Button: buttonLight
  },
  self
})

export interface ColorPickerTheme extends Theme<
  'ColorPicker',
  ColorPickerThemeVars,
  {
    Input: InputTheme
    Button: ButtonTheme
  }
> {}

export interface ColorPickerThemeOverrides extends ExtractThemeOverrides<ColorPickerTheme> {}

export default colorPickerLight
